import { GrowthBook } from '@growthbook/growthbook'
import { autoAttributesPlugin, thirdPartyTrackingPlugin } from '@growthbook/growthbook/plugins'
import { IS_PROD_ENV } from '@gto/helpers/env-checkers'

const GROWTHBOOK_CLIENT_KEY = IS_PROD_ENV ? 'sdk-13ytZvXhnjF2RL6' : 'sdk-k83qoRgIfIH2jxQU'

export const gb = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: GROWTHBOOK_CLIENT_KEY,
  enableDevMode: !IS_PROD_ENV,
  trackingCallback: IS_PROD_ENV
    ? undefined
    : (experiment, result) => {
        console.log('Viewed Experiment', {
          experimentId: experiment.key,
          variationId: result.key,
        })
      },
  plugins: [autoAttributesPlugin(), thirdPartyTrackingPlugin({ trackers: ['gtag', 'gtm'] })],
})
